import type { CSSProperties } from 'react'

// Re-export base styles from the original file
export {
  animatorStyle,
  groupNameStyle,
  positionerStyle,
  resultItemStyle,
  searchStyle,
  shortcutContainerStyle,
  shortcutKeyStyle,
} from '../problems-command-palette.styles'

// Series header styles
export const seriesHeaderStyle: CSSProperties = {
  padding: '12px 20px',
  backgroundColor: '#f0f9ff',
  borderBottom: '1px solid #e5e5e5',
  fontSize: '13px',
}

export const seriesProblemStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '4px 0',
}

export const seriesNumberStyle: CSSProperties = {
  backgroundColor: '#3b82f6',
  color: '#ffffff',
  borderRadius: '50%',
  width: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '11px',
  fontWeight: 600,
}

export const hintTextStyle: CSSProperties = {
  fontSize: '11px',
  color: '#666666',
  marginTop: '8px',
}

// Merge-specific styles
export const mergeHeaderStyle: CSSProperties = {
  padding: '12px 20px',
  backgroundColor: '#fef3c7',
  borderBottom: '1px solid #fcd34d',
  fontSize: '13px',
}

export const conflictModalStyle: CSSProperties = {
  padding: '16px 20px',
  backgroundColor: '#fef2f2',
  borderBottom: '1px solid #fecaca',
  fontSize: '13px',
}

export const mergePreviewStyle: CSSProperties = {
  padding: '12px 20px',
  backgroundColor: '#f0fdf4',
  borderBottom: '1px solid #86efac',
  fontSize: '13px',
}

// Removal header styles
export const removalHeaderStyle: CSSProperties = {
  padding: '12px 20px',
  backgroundColor: '#fef2f2',
  borderBottom: '1px solid #fecaca',
  fontSize: '13px',
}

export const removalNumberStyle: CSSProperties = {
  backgroundColor: '#ef4444',
  color: '#ffffff',
  borderRadius: '50%',
  width: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '11px',
  fontWeight: 600,
}
